// 拼客(PinKe)品牌9色魔方颜色系统
// 这9种颜色在启动动画、底部导航LOGO、首页模块中必须保持一致

export const PINKE_BRAND_COLORS = [
  '#FF6B35', // 0. 活力橙 (主色调) - 拼游
  '#4A90E2', // 1. 科技蓝 - 拼车  
  '#7ED321', // 2. 生机绿 - 拼饭
  '#F7931E', // 3. 温暖黄 - 拼购
  '#9B59B6', // 4. 优雅紫 - 拼活动
  '#E74C3C', // 5. 热情红
  '#1ABC9C', // 6. 清新薄荷
  '#34495E', // 7. 深空灰
  '#F39C12', // 8. 金橙色
] as const;

// 功能模块专用颜色映射 - 统一为字符串格式
export const MODULE_COLORS = {
  travel: PINKE_BRAND_COLORS[0],    // 拼游 - 活力橙
  carpool: PINKE_BRAND_COLORS[1],   // 拼车 - 科技蓝
  dining: PINKE_BRAND_COLORS[2],    // 拼饭 - 生机绿
  shopping: PINKE_BRAND_COLORS[3],  // 拼购 - 温暖黄
  toolbox: PINKE_BRAND_COLORS[4],   // 工具箱 - 优雅紫
  grouporder: PINKE_BRAND_COLORS[5],    // 团购订单 - 热情红
  ledger: PINKE_BRAND_COLORS[6],    // 个人账本 - 清新薄荷
  todo: PINKE_BRAND_COLORS[7],      // todo - 深空灰
  market: PINKE_BRAND_COLORS[8],    // 商城 - 金橙色
  discovery: PINKE_BRAND_COLORS[1], // 发现 - 科技蓝
  health: PINKE_BRAND_COLORS[8],    // 拼卡 - 金橙色
  template: PINKE_BRAND_COLORS[4],  // 模板 - 优雅紫
} as const;

// 功能模块的扩展颜色 - 为需要多种颜色变体的模块提供扩展颜色数组
export const MODULE_COLOR_VARIANTS = {
  ledger: [PINKE_BRAND_COLORS[6], '#12A092', '#0E8476'],    // 个人账本 - 清新薄荷及其变体
  todo: [PINKE_BRAND_COLORS[7], '#2C3E50', '#1F2C38'],      // todo - 深空灰及其变体
};

// 9色魔方标准排列顺序 (3x3网格)
// 用于启动动画、底部导航LOGO等地方
export const MAGIC_CUBE_LAYOUT = [
  [PINKE_BRAND_COLORS[0], PINKE_BRAND_COLORS[1], PINKE_BRAND_COLORS[2]], // 第一行
  [PINKE_BRAND_COLORS[3], PINKE_BRAND_COLORS[4], PINKE_BRAND_COLORS[5]], // 第二行
  [PINKE_BRAND_COLORS[6], PINKE_BRAND_COLORS[7], PINKE_BRAND_COLORS[8]], // 第三行
] as const;

// 导出扁平化的排列顺序（用于动画等场景）
export const MAGIC_CUBE_FLAT = MAGIC_CUBE_LAYOUT.flat();

// 颜色名称映射（用于调试和文档）
export const COLOR_NAMES = [
  '活力橙', '科技蓝', '生机绿', '温暖黄', '优雅紫',
  '热情红', '清新薄荷', '深空灰', '金橙色'
] as const;
